import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stb_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // token expired or invalid
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/signup") && window.location.pathname !== "/") {
        localStorage.removeItem("stb_token");
      }
    }
    return Promise.reject(err);
  }
);

export const CATEGORIES = [
  { value: "food", label: "Food", emoji: "🍕" },
  { value: "travel", label: "Travel", emoji: "✈️" },
  { value: "rent", label: "Rent", emoji: "🏠" },
  { value: "entertainment", label: "Entertainment", emoji: "🎉" },
  { value: "shopping", label: "Shopping", emoji: "🛍️" },
  { value: "utilities", label: "Utilities", emoji: "💡" },
  { value: "general", label: "General", emoji: "💸" },
];

export const GROUP_TYPES = [
  { value: "home", label: "Home", emoji: "🏠" },
  { value: "travel", label: "Travel", emoji: "✈️" },
  { value: "food", label: "Food", emoji: "🍕" },
  { value: "event", label: "Event", emoji: "🎉" },
  { value: "work", label: "Work", emoji: "💼" },
  { value: "college", label: "College", emoji: "🎓" },
  { value: "custom", label: "Custom", emoji: "⚙️" },
];

export const ACCENT_COLORS = [
  { value: "#00FF66", label: "Volt" },
  { value: "#007AFF", label: "Electric" },
  { value: "#FF3B30", label: "Signal" },
  { value: "#BF5AF2", label: "Violet" },
  { value: "#FF9500", label: "Amber" },
  { value: "#00D4FF", label: "Cyan" },
];

export const CURRENCIES = [
  { value: "USD", symbol: "$" },
  { value: "EUR", symbol: "€" },
  { value: "GBP", symbol: "£" },
  { value: "INR", symbol: "₹" },
  { value: "JPY", symbol: "¥" },
  { value: "CAD", symbol: "C$" },
  { value: "AUD", symbol: "A$" },
];

export const currencySymbol = (code) =>
  CURRENCIES.find((c) => c.value === code)?.symbol ?? code;

export const formatAmount = (n, code = "USD") => {
  const sym = currencySymbol(code);
  let v = Number(n || 0);
  // Round to 2 decimals first, then strip negative zero to avoid "-$0.00" displays
  v = Math.round(Math.abs(v) * 100) / 100;
  if (Object.is(v, -0)) v = 0;
  return `${sym}${v.toFixed(2)}`;
};

/**
 * Returns a clean signed amount string like "+$12.34" / "-$12.34" / "$0.00".
 * Never returns "-$0.00".
 */
export const formatSigned = (n, code = "USD") => {
  const sym = currencySymbol(code);
  const v = Math.round(Number(n || 0) * 100) / 100;
  if (Math.abs(v) < 0.005) return `${sym}0.00`;
  const sign = v > 0 ? "+" : "-";
  return `${sign}${sym}${Math.abs(v).toFixed(2)}`;
};
